import { RecurrenceInput } from './recurrence-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'

export const RecurrenceField = LabelFieldFactory({ InputComponent: RecurrenceInput })
